export default "__VITE_ASSET__BTQJb2Z___"